package com.essntl.features.supplier.data.supabase

import com.essntl.features.supplier.domain.model.SupplierModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun SupplierModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()
    currency?.let { requestMap["currency"] = JsonPrimitive(it) }
    description?.let { requestMap["description"] = JsonPrimitive(it) }
    contactName?.let { requestMap["contact_name"] = JsonPrimitive(it) }
    area?.let { area -> requestMap["area"] = JsonPrimitive(if (area.isEmpty) null else area.id) }
    category?.let { category -> requestMap["category"] = JsonPrimitive(if (category.isEmpty) null else category.id) }
    contact?.let { requestMap["contact_id"] = JsonPrimitive(it.id) }
    return requestMap
}